import { useProfile } from "@/context/useProfileProps";
import { ModalLoadingTypes } from "@/types/common";
import React, { useLayoutEffect, useState } from "react";

import ProfileModal from "@/components/common/profileModal";
import { useSendEmailOTP } from "@/components/profile/contactCard/query";
import {
  EmailFlowWrapperProps,
  OTPRef,
} from "@/components/profile/contactCard/types";

import EmailOTP from "./EmailOTP";

const EmailFlowWrapper = ({
  isEdit,
  closeEdit,
  email,
  isCalledFromOutside = false,
  otpRef,
  handleFooterBtnLoading,
}: EmailFlowWrapperProps) => {
  const {
    isMobile,
    translation: { contactCard, errorMessages },
    showToast,
  } = useProfile();
  const search = window.location.search;
  let urlParams = new URLSearchParams(search);
  const isApp = urlParams.get("app");
  const { mutate: sendEmailOTP } = useSendEmailOTP();
  // api call to send email otp
  const [emailOTPId, setEmailOTPId] = useState("");
  const [loading, setLoading] = useState({
    isSaveLoading: false,
    isDeleteLoading: false,
  });

  const handleLoading = (e: ModalLoadingTypes) => {
    setLoading((prev) => ({ ...prev, ...e }));
    if (e.isSaveLoading !== undefined && handleFooterBtnLoading) {
      handleFooterBtnLoading({ isSaveLoading: e.isSaveLoading });
    }
  };

  const sendEmailOTPHandler = async (email: string) => {
    handleLoading({ isSaveLoading: true });
    // api call to send email otp
    const apiData = {
      email: email,
    };

    // api call to send mobile otp
    sendEmailOTP(apiData, {
      onSuccess: (data) => {
        setEmailOTPId(data?.id);
        handleLoading({ isSaveLoading: false });
        showToast({
          show: true,
          type: "success",
          message: "OTP sent successfully",
        });
      },
      onError: (err) => {
        handleLoading({ isSaveLoading: false });
        showToast({
          show: true,
          type: "error",
          message:
            err instanceof Error
              ? err.message
              : errorMessages.somethingWentWrong,
        });
      },
    });
  };

  useLayoutEffect(() => {
    if (email && isEdit) {
      sendEmailOTPHandler(email);
    }
  }, [email, isEdit]);

  const renderForm = (
    <EmailOTP
      closeModal={closeEdit}
      email={email}
      otpId={emailOTPId}
      otpRef={otpRef}
      setLoading={(value: boolean) => handleLoading({ isSaveLoading: value })}
    />
  );

  return !isCalledFromOutside ? (
    <ProfileModal
      showModal={isEdit}
      closeModal={closeEdit}
      showCloseButton={true}
      isMobile={isMobile}
      screenAlignment={isMobile ? "bottom-sheet" : "center"}
      heading={contactCard.verifyEmailHeading}
      footerPrimaryBtnLabel={contactCard.confirmBtnLabel}
      footerPrimaryBtnHandler={() => {
        otpRef.current?.verifyOTPHandler();
      }}
      footerPrimaryBtnIsLoading={loading.isSaveLoading}
      customClass={isMobile && isApp ? "h-[70vh]" : ""}
    >
      {renderForm}
    </ProfileModal>
  ) : (
    renderForm
  );
};

export default EmailFlowWrapper;
